// This is the select dropdown costumized for our use, the options and names are passed down to it
// as props in the page that it is imported
// The value of the select input component is stored in a hidden input with id={props.name + "-filter"}
// inside the HTML DOM to be accessible through the whole application
import React, { useState, useEffect } from "react";
import "../../../../../Assets/Styles/Select.scss";
const Select = (props) => {
  const [PreSelected, setPreSelected] = useState("");
  const [IsOpen, setIsOpen] = useState(true);
  const [PrevId, setPrevId] = useState(""); // saved to disable previous item in the options list
  const [PreviousValue, setPreviousValue] = useState("");
  const [PreviousName, setPreviousName] = useState("");

  useEffect(() => {
    if (props.Name && !props.NoSelectStyles) {
      setPreSelected(props.Name);
    } else {
      setPreSelected(props.Initial);
    }
    if (props.PreSelected && !props.NoSelectStyles) {
      document.getElementById("pre-selected-" + props.Id).style.color =
        "rgb(71, 79, 89)";
    }
    if (props.PreSelected) {
      document.getElementById(props.Id + "-filter").value = props.PreSelectedId;
    }
    setTimeout(() => {
      if (
        props.PreSelectedId &&
        !props.NoSelectStyles &&
        document.getElementById(props.Id + "-filter")
      ) {
        document.getElementById(props.Id + "-filter").value =
          props.PreSelectedId;
        if (
          document.getElementById(
            "option-" + props.PreSelectedId + props.Id
          ) !== null
        ) {
          document
            .getElementById("option-" + props.PreSelectedId + props.Id)
            .classList.add("pre-selected");
        }
      }
    }, 100);
  }, [props.Name]);

  const handleDropDown = () => {
    setIsOpen(!IsOpen);
    if (IsOpen) {
      document
        .getElementById(props.Id + "-select")
        .classList.add("select-dropdown-is-open");
    } else {
      document
        .getElementById(props.Id + "-select")
        .classList.remove("select-dropdown-is-open");
    }
  };
  const selectItem = (option) => {
    document
      .getElementById(props.Id + "-select")
      .classList.remove("cx-select-error-shown");
    if (option.Name) {
      selectOptionWithName(option);
    } else {
      selectOptionWithoutName(option);
    }
    if (props.ChangeHandler) {
      props.ChangeHandler();
    }
  };
  // this function is only called when selecting an option in case the component
  // has a IsWithId prop set to true.
  const selectOption = (option) => {
    setPrevId("option-" + option.id + props.Id);
    document
      .getElementById(props.Id + "-select")
      .classList.remove("cx-select-error-shown");
    document.getElementById(props.Id + "-filter").value = option.id;

    setPreviousValue(option.id);
    setPreviousName(option.name);

    if (!props.NoSelectStyles) {
      document
        .getElementById("option-" + option.id + props.Id)
        .classList.add("pre-selected");
    }

    if (
      document.getElementById("option-" + props.PreSelectedId + props.Id) !==
      null
    ) {
      document
        .getElementById("option-" + props.PreSelectedId + props.Id)
        .classList.remove("pre-selected");
    }
    if (props.PreSelectedId == option.id) {
      document
        .getElementById("option-" + props.PreSelectedId + props.Id)
        .classList.add("pre-selected");
    }
    props.ChangeHandler(option);
    setPreSelected(option.name);
    if (PrevId.length === 0) {
      document.getElementById("pre-selected-" + props.Id).style.color =
        "#474F59";
    } else {
      if (!props.NoSelectStyles) {
        document.getElementById(PrevId).classList.remove("pre-selected");
      }
    }
  };
  const selectOptionWithoutName = (option) => {
    setPreSelected(option);
    document.getElementById(props.Id + "-filter").value = option;
    setPrevId("option-" + option + props.Id);
    if (!props.NoSelectStyles) {
      document
        .getElementById("option-" + option + props.Id)
        .classList.add("pre-selected");
    }
    if (PrevId.length === 0) {
      document.getElementById("pre-selected-" + props.Id).style.color =
        "#474F59";
    } else {
      if (!props.NoSelectStyles) {
        document.getElementById(PrevId).classList.remove("pre-selected");
      }
    }
  };
  const selectOptionWithName = (option) => {
    setPreSelected(option.Name);
    document.getElementById(props.Id + "-filter").value = option.Id;
    setPrevId("option-" + option + props.Id);
    if (props.PreSelected && !props.NoSelectStyles) {
      document
        .getElementById("option-" + option + props.Id)
        .classList.add("pre-selected");
    }
    if (PrevId.length === 0) {
      document.getElementById("pre-selected-" + props.Id).style.color =
        "#474F59";
    } else {
      if (!props.NoSelectStyles) {
        document.getElementById(PrevId).classList.remove("pre-selected");
      }
    }
  };
  const shortenText = (SelectedText) => {
    // console.log(typeof parseInt(SelectedText));
    if (typeof parseInt(SelectedText) === "number") {
      return SelectedText;
    } else {
      if (SelectedText.length < 35) {
        return SelectedText;
      } else {
        return SelectedText.slice(0, 35) + " ...";
      }
    }
  };
  return (
    <React.Fragment>
      {props.IsWithId ? (
        <React.Fragment>
          {!IsOpen ? (
            <div
              onClick={() => handleDropDown()}
              className="select-outline-area"
              id={props.Id + "-outline"}
            ></div>
          ) : null}
          <div
            className={
              props.ClassName ? props.ClassName + " cx-select" : "cx-select"
            }
            id={props.Id + "-select"}
            onClick={() => handleDropDown()}
          >
            <input className="hidden" id={props.Id + "-filter"} />
            <input
              className="hidden"
              id={props.Id + "-previous-value"}
              value={PreviousValue}
              onChange={(e) => console.log("e", e)}
            />
            <input
              className="hidden"
              id={props.Id + "-previous-name"}
              value={PreviousName}
              onChange={(e) => console.log("e", e)}
            />
            <input className="hidden" id={props.Id + "-filter-preselected"} />
            {props.IsDynamic ? (
              <input className="hidden" id={props.Id + "-children"} />
            ) : null}
            <p className="label-text" id={"pre-selected-" + props.Id}>
              {shortenText(PreSelected)}
            </p>
            <i className="feather-chevron-down"></i>
            {props.Options === undefined ? null : (
              <section className="cx-dropdown">
                {props.Options.map((option) => (
                  <p
                    key={"option-" + option.id + props.Id}
                    id={"option-" + option.id + props.Id}
                    className="option-item"
                    onClick={() => selectOption(option)}
                    value={option.id}
                  >
                    {option.name ? option.name : option}
                    <i className="feather-check"></i>
                  </p>
                ))}
              </section>
            )}
            <p className="select-validation-message">{props.ValidationError}</p>
          </div>
        </React.Fragment>
      ) : (
        <React.Fragment>
          {!IsOpen ? (
            <div
              onClick={() => handleDropDown()}
              className="select-outline-area"
            ></div>
          ) : null}
          {props.ClassName ? (
            <div
              className={props.ClassName}
              id={props.Id + "-select"}
              onClick={() => handleDropDown()}
            >
              <input className="hidden" id={props.Id + "-filter"} />
              <p className="label-text" id={"pre-selected-" + props.Id}>
                {shortenText(PreSelected)}
              </p>
              <i className="feather-chevron-down"></i>
              <section className="cx-dropdown">
                {props.Options.map((option) => (
                  <p
                    id={"option-" + option + props.Id}
                    className="option-item"
                    onClick={() => selectItem(option)}
                  >
                    {option}
                    <i className="feather-check"></i>
                  </p>
                ))}
              </section>
              <p> {props.Validationerror} </p>
            </div>
          ) : (
            <React.Fragment>
              {props.Width ? (
                <div
                  className="cx-select"
                  id={props.Id + "-select"}
                  onClick={() => handleDropDown()}
                  style={{ width: props.Width }}
                >
                  <input className="hidden" id={props.Id + "-filter"} />
                  <p className="label-text" id={"pre-selected-" + props.Id}>
                    {shortenText(PreSelected)}
                  </p>
                  <i className="feather-chevron-down"></i>
                  <section className="cx-dropdown">
                    {props.Options.map((option) => (
                      <p
                        id={"option-" + option + props.Id}
                        className="option-item"
                        onClick={() => selectItem(option)}
                      >
                        {option}
                        <i className="feather-check"></i>
                      </p>
                    ))}
                  </section>
                </div>
              ) : (
                <div
                  className="cx-select"
                  id={props.Id + "-select"}
                  onClick={() => handleDropDown()}
                >
                  <input className="hidden" id={props.Id + "-filter"} />
                  <p className="label-text" id={"pre-selected-" + props.Id}>
                    {shortenText(PreSelected)}
                  </p>
                  <i className="feather-chevron-down"></i>
                  <section className="cx-dropdown">
                    {props.Options.map((option) => (
                      <p
                        id={"option-" + option + props.Id}
                        className="option-item"
                        onClick={() => selectItem(option)}
                      >
                        {option.Name ? option.Name : option}
                        <i className="feather-check"></i>
                      </p>
                    ))}
                  </section>
                  <p className="select-validation-message">
                    {props.ValidationError}
                  </p>
                </div>
              )}
            </React.Fragment>
          )}
        </React.Fragment>
      )}
    </React.Fragment>
  );
};
export default Select;
